import React from 'react';
import { Redirect } from 'react-router-dom';
import Yorum from 'src/views/Chat';
import DashboardView from 'src/views/Dashboard';
import Error404 from 'src/views/Error404';
import Login from 'src/views/Login';
import OverView from 'src/views/Overview';
import MaterialOrder from 'src/views/MaterialOrder';
import Profil from 'src/views/Profile';
import Isler from 'src/views/WorkOrder';
import AuthLayout from './layouts/Auth';
import DashboardLayout from './layouts/Dashboard';
import ErrorLayout from './layouts/Error';
import BultenlerView from './views/Bulletin';
import DosyaView from './views/File';
import YardimView from './views/Help';
import MalzemeIhtiyacView from './views/MaterialRequirement';
import ProdcutDetailControlView from './views/ProductDetailControl';
import ServisIletisimView from './views/ServiceContact';
import TodaySummaryView from './views/TodaySummary';
import UyariMerkeziView from './views/WarningCenter';
import TeknikYonetimView from './views/TechnicianManagement';
import TechnicalKnowledgeBase from './views/TechnicalKnowledgeBase';
import MaterialServiceShopReport from './views/MaterialServiceShopReport';
import WatchListView from './views/WatchList';
import ServiceShopMaterialView from './views/ServiceShopMaterial';
import PaymentReportView from './views/PaymentReport';
import ServiceOffWorkView from 'src/views/ServiceOffWork';
import Dashboard from './views/Dashboard';
import UnauthorizedView from 'src/views/Unauthorized';
import ProductReleaseView from 'src/views/ProductRelease';
import FleetCostManagementView from './views/FleetCostManagement';
import ForConsumer from 'src/views/MaterialOrder2/Create/ForConsumer';
import ForPartner from './views/MaterialOrder2/Create/ForPartner';
import ForOTC from './views/MaterialOrder2/Create/ForOTC';
import Query from './views/MaterialOrder2/Query';
import Return from './views/MaterialOrder2/Return';
import MyReturnsReport from './views/MaterialOrder2/MyReturnsReport';
import MaterialOrderManagement from './views/MaterialOrder2/MaterialOrderManagement';
import OwnEngineerMaterials from './views/OwnEngineerMaterials';
import PartnerReportView from './views/PartnerReport';
import RepairForConsumer from 'src/views/TradePartnerEU/RepairForConsumer';
import WorkOrderList from 'src/views/TradePartnerEU/WorkOrderList';
import Compensation from 'src/views/TradePartnerEU/Compensation';
import UpliftRequestForm from 'src/views/TradePartnerUK/UpliftRequestForm';
import {
  getOverviewRestrictedRedirectPath,
  getUser,
  isOverviewRestrictedUser
} from 'src/utils/Common';

const restrictOverviewRoute = Component => props => {
  if (isOverviewRestrictedUser(getUser())) {
    return <Redirect to={getOverviewRestrictedRedirectPath()} />;
  }

  return <Component {...props} />;
};

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: Login
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: Error404
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/Unauthorized',
    component: ErrorLayout,
    routes: [
      {
        path: '/Unauthorized',
        exact: true,
        component: UnauthorizedView
      },
      {
        component: () => <Redirect to="/Unauthorized" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/Dashboard',
        exact: true,
        component: Dashboard
      },
      {
        path: '/chat',
        exact: true,
        component: Yorum
      },
      {
        path: '/chat/:id',
        exact: true,
        component: Yorum
      },
      {
        path: '/dashboards/default',
        exact: true,
        component: TodaySummaryView
      },
      {
        path: '/WorkOrder/:id/:tab',
        exact: true,
        component: Isler
      },
      {
        path: '/overview',
        exact: true,
        component: restrictOverviewRoute(OverView)
      },
      {
        path: '/Dashboard',
        exact: true,
        component: DashboardView
      },
      {
        path: '/materialOrder',
        exact: true,
        component: MaterialOrder
      },
      {
        path: '/tradepartner/repairforconsumer',
        exact: true,
        component: RepairForConsumer
      },
      {
        path: '/tradepartner/workorderlist',
        exact: true,
        component: WorkOrderList
      },
      {
        path: '/tradepartner/compensation',
        exact: true,
        component: Compensation
      },
      {
        path: '/tradepartner/upliftrequestform',
        exact: true,
        component: UpliftRequestForm
      },
      {
        path: '/Bultenler',
        exact: true,
        component: BultenlerView
      },
      {
        path: '/Dosya',
        exact: true,
        component: DosyaView
      },
      {
        path: '/ProductDetailControl',
        exact: true,
        component: ProdcutDetailControlView
      },
      {
        path: '/MalzemeIhtiyac',
        exact: true,
        component: MalzemeIhtiyacView
      },
      {
        path: '/UyariMerkezi',
        exact: true,
        component: UyariMerkeziView
      },
      {
        path: '/TechnicianManagement',
        exact: true,
        component: TeknikYonetimView
      },
      
      {
        path: '/TechnicalKnowledgeBase',
        exact: true,
        component: TechnicalKnowledgeBase
      },
      {
        path: '/MaterialServiceShopReport',
        exact: true,
        component: MaterialServiceShopReport
      },
      {
        path: '/WatchList',
        exact: true,
        component: WatchListView
      },
      {
        path: '/FleetCostManagement',
        exact: true,
        component: FleetCostManagementView
      },
      {
        path: '/ServiceShopMaterial',
        exact: true,
        component: ServiceShopMaterialView
      },
      {
        path: '/PaymentReport',
        exact: true,
        component: PaymentReportView
      },
      {
        path: '/PartnerReport',
        exact: true,
        component: PartnerReportView
      },      
      {
        path: '/ProductRelease',
        exact: true,
        component: ProductReleaseView
      },
      {
        path: '/ServisIletisim',
        exact: true,
        component: ServisIletisimView
      },
      {
        path: '/ServiceOffWork',
        exact: true,
        component: ServiceOffWorkView
      },
      {
        path: '/Yardim',
        exact: true,
        component: YardimView
      },
      {
        path: '/profile/:id',
        exact: true,
        component: Profil
      },
      {
        path: '/profile/:id/:tab',
        exact: true,
        component: Profil
      },
      {
        path: '/materialOrder2/Query',
        exact: true,
        component: Query
      },

      {
        path: '/materialOrder2/Create/ForConsumer',
        exact: true,
        component: ForConsumer
      },
      {
        path: '/materialOrder2/Create/ForPartner',
        exact: true,
        component: ForPartner
      },
      {
        path: '/materialOrder2/Create/ForOTC',
        exact: true,
        component: ForOTC
      },
      {
        path: '/materialOrder2/Return',
        exact: true,
        component: Return
      },
      {
        path: '/materialOrder2/MyReturnsReport',
        exact: true,
        component: MyReturnsReport
      },
      {
        path: '/materialOrder2/MaterialOrderManagement',
        exact: true,
        component: MaterialOrderManagement
      },
      {
        path: '/OwnEngineerMaterials',
        exact: true,
        component: OwnEngineerMaterials
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
